/**
 * @note
 * Data for maps:
 * 1. `LOCALE_BY_LANGUAGE_NAME`
 * 2. `LANGUAGE_ID_BY_LOCALE`
 * can be taken from the `project` CMS/admin panel:
 */
export const LOCALE_BY_LANGUAGE_NAME = {
  ENGLISH: 'en',
  RUSSIAN: 'ru',
  GERMAN: 'de',
  FRENCH: 'fr',
  ITALIAN: 'it',
  SPANISH: 'es',
  PORTUGUESE: 'pt',
  JAPANESE: 'ja',
  KOREAN: 'ko',
  CHINESE: 'zh',
  CHINESE_TAIWAN: 'tw',
  TURKISH: 'tr',
  UKRAINIAN: 'uk',
  DUTCH: 'nl',
};

const LOCALE_COOKIE_NAME = 'locale';

const LOCALE_COOKIE_OPTIONS = {
  path: '/',
  sameSite: 'strict',
  maxAge: 60 * 60 * 24 * 365, // expires after one year (in seconds)
} as const;

export const DEFAULT_LOCALE = LOCALE_BY_LANGUAGE_NAME.ENGLISH;

export const LANGUAGE_ID_BY_LOCALE = {
  [LOCALE_BY_LANGUAGE_NAME.ENGLISH]: '1',
  [LOCALE_BY_LANGUAGE_NAME.RUSSIAN]: '2',
  [LOCALE_BY_LANGUAGE_NAME.GERMAN]: '3',
  [LOCALE_BY_LANGUAGE_NAME.FRENCH]: '4',
  [LOCALE_BY_LANGUAGE_NAME.ITALIAN]: '5',
  [LOCALE_BY_LANGUAGE_NAME.SPANISH]: '6',
  [LOCALE_BY_LANGUAGE_NAME.PORTUGUESE]: '7',
  [LOCALE_BY_LANGUAGE_NAME.JAPANESE]: '9',
  [LOCALE_BY_LANGUAGE_NAME.KOREAN]: '14',
  [LOCALE_BY_LANGUAGE_NAME.CHINESE]: '15',
  [LOCALE_BY_LANGUAGE_NAME.CHINESE_TAIWAN]: '17',
  [LOCALE_BY_LANGUAGE_NAME.TURKISH]: '18',
  [LOCALE_BY_LANGUAGE_NAME.UKRAINIAN]: '20',
  [LOCALE_BY_LANGUAGE_NAME.DUTCH]: '22',
};

export const LANGUAGE_ID_HEADER_NAME = 'language_id';

/**
 * @note
 * This header name is predefined by the `next-i18n-router` NPM package
 */
export const I18N_ROUTER_LOCALE_HEADER_NAME = 'x-next-i18n-router-locale';

/**
 * Configuration object used in `I18nRouterWrapperMiddleware`
 */
export const i18nConfig = {
  locales: Object.values(LOCALE_BY_LANGUAGE_NAME),
  defaultLocale: LOCALE_BY_LANGUAGE_NAME.ENGLISH,

  /**
   * @param {string} i18nConfig.localeCookie - locale cookie name
   */
  localeCookie: LOCALE_COOKIE_NAME,
  localeDetector: false as const,

  /**
   * @param {Object} i18nConfig.cookieOptions - locale cookie options
   */
  cookieOptions: LOCALE_COOKIE_OPTIONS,
  basePath: '',
  serverSetCookie: 'always' as 'always' | 'if-empty' | undefined,
  noPrefix: false,

  /**
   * @param {Object} i18nConfig.prefixDefault - if this param is set to `false`, we will not be able to use chain of
   * middlewares using the `flowByMiddlewares` utility
   */
  prefixDefault: true,
};
